/* eslint-disable */
import {CognitoAuth, StorageHelper} from 'amazon-cognito-auth-js';
import routes from '@/routes';
import store from '@/store';

const CLIENT_ID = process.env.VUE_APP_COGNITO_CLIENT_ID;
const APP_DOMAIN = process.env.VUE_APP_COGNITO_APP_DOMAIN;
const REDIRECT_URI = process.env.VUE_APP_COGNITO_REDIRECT_URI;
const USERPOOL_ID = process.env.VUE_APP_COGNITO_USERPOOL_ID;
const REDIRECT_URI_SIGNOUT = process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT;
const CLAVEUNICA_LOGOUT = process.env.VUE_APP_CLAVEUNICA_LOGOUT;

var authData = {
  ClientId: CLIENT_ID, // Your client id here
  AppWebDomain: APP_DOMAIN,
  TokenScopesArray: ['openid', 'email', 'profile'],
  RedirectUriSignIn: REDIRECT_URI,
  RedirectUriSignOut: REDIRECT_URI_SIGNOUT,
  UserPoolId: USERPOOL_ID,
}

var auth = new CognitoAuth(authData);

auth.userhandler = {
  onSuccess: function (result) {
    store.commit('setLoggedIn', true);
    store.dispatch('getUserInfo')
      .then(data => {
        routes.push({name: 'home'})
          .catch(err => {});
      })
      .catch(err => {
        console.error('Error getUserInfo', err)
        const userInfoKey = this.getUserInfoStorageKey();
        auth.signOut();
        storage.removeItem(userInfoKey);
      });
  },
  onFailure: function (err) {
    console.error("cognito failure", err)
    store.commit('setLoggedOut');

    routes.push({path: '/logout'})
      .catch(error => {});
  }
};

function getUserInfoStorageKey() {
  const keyPrefix = 'CognitoIdentityServiceProvider.' + auth.getClientId();
  const tokenUserName = auth.signInUserSession.getAccessToken().getUsername();
  return keyPrefix + '.' + tokenUserName + '.userInfo';
}

const storageHelper = new StorageHelper();
const storage = storageHelper.getStorage();

export default {
  auth: auth,
  login() {
    auth.getSession();
  },
  logout() {
    if (auth.isUserSignedIn()) {
      const userInfoKey = this.getUserInfoStorageKey();
      auth.signOut();

      storage.removeItem(userInfoKey);
    }
  },
  logoutClaveUnica() {
    window.location.href = CLAVEUNICA_LOGOUT

    this.logout()
  },
  getUserInfoStorageKey,

}
